import { API2_HOST } from 'helpers/urlHelper';
import axios from 'services/api';

export const getDepartments = async () => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/department-spending/departments`
  });
};

export const getFinancialYears = async () => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/department-spending/financial-years`
  });
};

export const getDepartmentSpendingSummary = async (
  department,
  financialYearId
) => {
  return await axios({
    method: 'GET',
    url: `${API2_HOST}/department-spending/summary?department=${department}&financialYearId=${financialYearId}`
  });
};

export const getDepartmentSpendingTransactions = async ({
  department,
  accountNumber,
  financialYearId,
  periodId,
  pageNum = 1,
  pageSize = 50
}) => {
  const params = new URLSearchParams({
    department,
    accountNumber,
    financialYearId,
    pageNum,
    pageSize
  });
  if (periodId) params.set('periodId', periodId);

  return await axios({
    method: 'GET',
    url: `${API2_HOST}/department-spending/transactions?${params.toString()}`
  });
};
